import React from 'react';
import '../styles/tavern-components.css';

export interface TavernDayHeaderProps {
  day: string;
  date: string;
  isToday?: boolean;
  className?: string;
  uppercase?: boolean;
}

/**
 * Sticky day header for dashboard pages
 *
 * @example
 * <TavernDayHeader
 *   day="Tuesday"
 *   date="13 January"
 *   isToday={false}
 * />
 *
 * @example
 * <TavernDayHeader
 *   day="Wednesday"
 *   date="14 January"
 *   isToday={true}
 * />
 */
export function TavernDayHeader({
  day,
  date,
  isToday = false,
  className = '',
  uppercase = true,
}: TavernDayHeaderProps) {
  const todayClass = isToday ? 'tavern-day-header--today' : '';
  const caseClass = uppercase ? '' : 'tavern-day-header--no-uppercase';
  const dayText = uppercase ? day.toUpperCase() : day;
  const dateText = uppercase ? date.toUpperCase() : date;

  return (
    <div className={`tavern-day-header ${todayClass} ${caseClass} ${className}`.trim()}>
      {dayText} {dateText}
    </div>
  );
}

export interface TavernTableHeaderProps {
  tableName: string;
  capacity: number;
  className?: string;
}

/**
 * Table/resource subheader for grouping events
 * 
 * @example
 * <TavernTableHeader tableName="Table #1" capacity={5} />
 */
export function TavernTableHeader({
  tableName,
  capacity,
  className = '',
}: TavernTableHeaderProps) {
  return (
    <div className={`tavern-table-header ${className}`.trim()}>
      📍 {tableName} ({capacity} seats)
    </div>
  );
}

export interface TavernSectionHeaderProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Generic section header
 * 
 * @example
 * <TavernSectionHeader>
 *   Ping Pong Arena
 * </TavernSectionHeader>
 */
export function TavernSectionHeader({
  children,
  className = '',
}: TavernSectionHeaderProps) {
  return (
    <div className={`tavern-table-header ${className}`.trim()}>{children}</div>
  );
}
